export default function superAdminAuth({ next, router }) {
    if (!localStorage.getItem('super_admin_token')) {
        return router.push({ path: '/super-admin/login' });
    }
  
    return next();
}